// Reads the `userToken` passed by the OruClicks hub, stores it as the auth token
// used by every API call (see Action/api.js), and strips it from the address bar.
// Supports both `/?userToken=XXX` and the path form `/userToken=XXX`.
const TOKEN_PARAM = "userToken";
const AUTH_TOKEN_KEY = "authToken";
const DEFAULT_ROUTE = "/dashboard";

const captureUserToken = () => {
  try {
    const url = new URL(window.location.href);
    let token = url.searchParams.get(TOKEN_PARAM);
    let pathname = url.pathname;

    if (token !== null) {
      url.searchParams.delete(TOKEN_PARAM);
    } else {
      const pathMatch = pathname.match(/\/userToken=([^/]*)\/?$/);
      if (!pathMatch) return;
      token = decodeURIComponent(pathMatch[1]);
      pathname = pathname.slice(0, pathMatch.index) || "/";
    }

    token = token.trim();
    if (token) {
      localStorage.setItem(AUTH_TOKEN_KEY, token);
    }

    // Arriving at the root with a token means the user launched the app, so open the dashboard
    if (pathname === "/" && token) {
      pathname = DEFAULT_ROUTE;
    }

    window.history.replaceState(
      window.history.state,
      document.title,
      `${pathname}${url.search}${url.hash}`
    );
  } catch (error) {
    console.error("Failed to capture userToken from URL:", error);
  }
};

export default captureUserToken;
